import React from 'react'

// Utility function to render nested objects
const renderObject = (obj: any): React.JSX.Element | string => {
  if (typeof obj !== 'object' || obj === null) {
    return String(obj)
  }

  return (
    <ul>
      {Object.entries(obj).map(([key, value]) => (
        <li key={key}>
          <strong>{key}:</strong> {renderObject(value)}
        </li>
      ))}
    </ul>
  )
}

type ComponentProps = {
  stagedOptions: Record<string, any>
  initialChanges: Record<string, any>
  currentOptions: Record<string, any>
}

const ChangesList: React.FC<ComponentProps> = props => {
  const { stagedOptions, initialChanges, currentOptions } = props

  return (
    <div>
      {Object.keys(stagedOptions).map(key => {
        const oldValue: any = initialChanges[key] !== undefined ? initialChanges[key] : currentOptions[key]
        const newValue: any = stagedOptions[key]
        return (
          <div key={key}>
            <strong>{key}</strong>: {renderObject(oldValue)} → {renderObject(newValue)}
          </div>
        )
      })}
    </div>
  )
}

export default ChangesList
